import React, { useState } from "react";
import { CustomButton2, CustomView } from "../../../../../../../components";
import {
  IUpdateStudent,
  ITiming,
  IWeeksDay,
} from "../../../../../../../types/student.interface";
import DayInformation from "./DayInformation";
import { useFormik } from "formik";
import * as Yup from "yup";
import utils from "../../../../../../../utils";

type Props = {
  defaultValue: IUpdateStudent;
  onSubmit: (arg: IUpdateStudent) => void;
  onBack: (arg: IUpdateStudent) => void;
};

const StudentTiming = (props: Props) => {
  // const {selectedUser} = React.useContext(Context.ServiceScreen);
  // const selectedTiming = selectedUser?.student?.timing;

  const [timing, setTiming] = useState<ITiming>({
    sunday: undefined,
    friday: undefined,
    monday: undefined,
    tuesday: undefined,
    saturday: undefined,
    thursday: undefined,
    wednesday: undefined,
  });

  React.useEffect(() => {
    if (!props.defaultValue?.timingMongoToHtml) {
      setTiming({
        sunday: props.defaultValue?.timing?.sunday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.sunday
            )
          : undefined,
        friday: props.defaultValue?.timing?.friday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.friday
            )
          : undefined,
        monday: props.defaultValue?.timing?.monday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.monday
            )
          : undefined,
        tuesday: props.defaultValue?.timing?.tuesday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.tuesday
            )
          : undefined,
        saturday: props.defaultValue?.timing?.saturday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.saturday
            )
          : undefined,
        thursday: props.defaultValue?.timing?.thursday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.thursday
            )
          : undefined,
        wednesday: props.defaultValue?.timing?.wednesday
          ? utils.convertServiceTiming.mongoToHtml(
              props.defaultValue.timing.wednesday
            )
          : undefined,
      });
    } else {
      setTiming(props.defaultValue?.timing as ITiming);
    }
  }, []);

  function onSubmitBack() {
    props.onBack({ ...props.defaultValue, timing, timingMongoToHtml: true });
    // console.log(props.defaultValue);
    // console.log({ ...props.defaultValue, timing });
  }

  const formik = useFormik<IUpdateStudent>({
    enableReinitialize: true,
    initialValues: {
      ...props?.defaultValue,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values: IUpdateStudent, { setSubmitting }) => {
      const formValues: IUpdateStudent = {
        ...values,
        timing,
      };
      Promise.resolve(props.onSubmit(formValues)).catch(() =>
        setSubmitting(false)
      );
    },
  });

  const submitHandler = () => {
    formik.submitForm();
  };

  console.log(timing);

  return (
    <CustomView.Container className="create-form-content scroll-y">
      {/* ==================================================== SATURDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.saturday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, saturday: event })
        }
        label="شنبه"
      />
      {/* ==================================================== SUNDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.sunday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, sunday: event })
        }
        label="یکشنبه"
      />
      {/* ==================================================== MONDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.monday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, monday: event })
        }
        label="دو شنبه"
      />
      {/* ==================================================== TUESDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.tuesday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, tuesday: event })
        }
        label="سه شنبه"
      />
      {/* =================================================== WEDNESDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.wednesday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, wednesday: event })
        }
        label="چهار شنبه"
      />
      {/* =================================================== THURSDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.thursday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, thursday: event })
        }
        label="پنج شنبه"
      />
      {/* ==================================================== FRIDAY ==================================================== */}
      <DayInformation
        defaultValue={timing.friday}
        onChange={(event: IWeeksDay) =>
          setTiming!({ ...timing, friday: event })
        }
        label="جمعه"
      />
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={onSubmitBack} title="قبلی" type="danger" />
        </CustomView.Column>
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={submitHandler} title="ثبت" />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default StudentTiming;
